'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
export const TYPING_SPEED = 50;
export const useTypingAnimation = t0 => {
  const $ = _c(9);
  const {
    text,
    speed: t1,
    delay: t2,
    play: t3
  } = t0;
  const speed = t1 === undefined ? 50 : t1;
  const delay = t2 === undefined ? 0 : t2;
  const play = t3 === undefined ? true : t3;
  const [displayed, setDisplayed] = useState("");
  const prevRef = useRef("");
  const rafRef = useRef(0);
  let t4;
  let t5;
  if ($[0] !== delay || $[1] !== play || $[2] !== speed || $[3] !== text) {
    t4 = () => {
      if (!play) {
        return;
      }
      const prev = prevRef.current;
      const isContinue = prev && text.startsWith(prev) && text.length > prev.length;
      const start = isContinue ? prev.length : 0;
      if (!isContinue) {
        setDisplayed("");
      }
      prevRef.current = text;
      let t0$0 = 0;
      const tick = ts => {
        if (!t0$0) {
          t0$0 = ts;
        }
        const i = Math.min(start + Math.floor((ts - t0$0) / speed), text.length);
        setDisplayed(text.slice(0, i));
        if (i < text.length) {
          rafRef.current = requestAnimationFrame(tick);
        }
      };
      const id = setTimeout(() => rafRef.current = requestAnimationFrame(tick), isContinue ? 0 : delay);
      return () => {
        clearTimeout(id);
        cancelAnimationFrame(rafRef.current);
      };
    };
    t5 = [text, speed, delay, play];
    $[0] = delay;
    $[1] = play;
    $[2] = speed;
    $[3] = text;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  const t6 = displayed === text;
  let t7;
  if ($[6] !== displayed || $[7] !== t6) {
    t7 = {
      displayedText: displayed,
      isComplete: t6
    };
    $[6] = displayed;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};